import * as React from 'react';
import { IApproveUserCriteria, IApproveUserResponse, IRegisterUser, IStringValue, IUserCriteria } from '../../types/types';
import { Theme, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { approveUser } from './userlist.actions';
import makeStyles from '@mui/styles/makeStyles';
import { Strings } from "../../types/enums";
import { getInfoJsonWithArray } from "../../utilities/utilities";

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        minWidth: "500px",
        maxwidth: "700px"
    }
}));

interface IModalDialogueProps {
    title: string,
    body: any,
    modalOpen: boolean,
    handleClose: any,
    selectedUser?: IRegisterUser,
    AssociateInstitutionId: number,
    isCreateNewInstitution: boolean,
    insertedBy: number,
    Address: any,
    institutionEmail?: string
}
const ScrollDialog = ({
    Address,
    isCreateNewInstitution,
    insertedBy,
    AssociateInstitutionId,
    selectedUser,
    title,
    body,
    modalOpen,
    handleClose,
    institutionEmail}: IModalDialogueProps) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const approveUserResponse: IApproveUserResponse = useSelector((state: any) => state.userListState.approveUserResponse);
    const descriptionElementRef = React.useRef<HTMLElement>(null);
    const [displayEmailWarningMessage, setDisplayEmailWarningMessage] = React.useState(false);
    const [emailWarningMessage, setEmailWarningMessage] = React.useState<string>("");

    const handleSubmitApproveUser = () => {

        if (!selectedUser)
            return;

        let criteria: IApproveUserCriteria = { insertedBy: insertedBy, associateInstitutionId: AssociateInstitutionId, isCreateNewInstitution: isCreateNewInstitution, registrationId: selectedUser.registrationId };
        dispatch(approveUser(criteria));
    };

    const processInfoResponse = (data: any) => {
        data.forEach((item: IStringValue) => {
            switch (item.key) {
                case Strings.RegistrationRequestDuplicateEmail:
                    setEmailWarningMessage(item.value);
                    break;
                default:
                    break;
            }
        });
    };

    React.useEffect(() => {
        const fetchInfoStrings = async () => {
            const data: any = await getInfoJsonWithArray([
                Strings.RegistrationRequestDuplicateEmail
            ]);
            processInfoResponse(data);
        };


        if (!modalOpen)
            return;

        fetchInfoStrings();

        setDisplayEmailWarningMessage(false);
        const { current: descriptionElement } = descriptionElementRef;

        if (descriptionElement)
            descriptionElement.focus();

    }, [modalOpen]);

    React.useEffect(() => {

        if (!approveUserResponse)
            return;

        handleClose(false);
        
    }, [approveUserResponse, dispatch, handleClose]);

    React.useEffect(() => {

        const fetchUserByEmail = async (email: string) => {

            let userCriteria: IUserCriteria = {
                email: email,
                includeInstitutionUsers: true,
            }

            try {
                let response = await fetch(`api/User/UserList`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(userCriteria),
                });

                if (!response.ok) {
                    throw new Error("Failed to retrieve user by email...");
                }

                return await response.json();

            }
            catch (error) {
                console.error(error);
                throw error;
            };

        }

        if (isCreateNewInstitution && selectedUser && institutionEmail) {
        
            fetchUserByEmail(institutionEmail)
                .then(data => {
                    if (data && data.length > 0) {

                        if (data.some((item: { id: number; }) => item.id !== selectedUser.id)) {
                            setDisplayEmailWarningMessage(true);
                        }

                    }
                })
                .catch(error => console.error("Error fetching user by email:", error));

        }

    }, [isCreateNewInstitution, selectedUser, institutionEmail]);

    const bodytext = "Please confirm the approval of this user. This approval will allow the user to submit claims on behalf of a new institution."
    const approveusertext = bodytext.split('.')

    return (
        <div>
            <Dialog
                open={modalOpen}
                onClose={handleClose}
                fullWidth
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                classes={{ paper: classes.paper }}
            >
                <DialogTitle id="scroll-dialog-title"
                    className="cmn-dialogtitle"
                >
                    {title}
                </DialogTitle>
                <DialogContent dividers={true}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        component="span"
                        tabIndex={-1}
                        className="cmn-dialogtext">
                        <Typography
                            component="span"
                            style={{ wordWrap: "break-word" }}
                            color="black"
                            className="cmn-dialogtext"
                        >
                            <p> {approveusertext[0]}.</p>
                            <p> {approveusertext[1]}</p>

                            <br />
                            <p className="bold-text">{Address} </p>
                        </Typography>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="inherit"
                        className="cmn-secbtn"
                        size="small"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        className="btn-primary"
                        disabled={displayEmailWarningMessage}
                        variant="contained"
                        onClick={handleSubmitApproveUser}
                        sx={{
                            opacity: displayEmailWarningMessage ? 0.5 : 1, // optional: visually indicate disabled
                            pointerEvents: displayEmailWarningMessage ? 'none' : 'auto', // optional: prevent interaction
                        }}

                    >
                        Approve
                    </Button>
                </DialogActions>
                {displayEmailWarningMessage && <p style={{ color: 'red', marginLeft: '15px' }}>{emailWarningMessage}</p>}
            </Dialog>
        </div>
    );
};

export default ScrollDialog;